/* <reading-progress> — the thin bar that tracks how far through the body you are.

   Replaces assets/article.js, which ran document-wide at parse time, threw when
   either element was missing, and never re-initialised when the Theme Editor
   re-rendered the section.

   Where the browser supports scroll-driven animations the bar is pure CSS
   (component-reading-progress.css) and this file attaches nothing at all — the
   whole thing runs off the compositor. The listener below is only the fallback. */
(function () {
  var NATIVE = window.CSS && CSS.supports && CSS.supports('animation-timeline', 'scroll()');

  class ReadingProgress extends HTMLElement {
    connectedCallback() {
      if (NATIVE) return;
      this.bar = this.querySelector('[data-progress-bar]');
      /* Scoped to the element's own configuration, not a document-wide guess. */
      var selector = this.getAttribute('data-target');
      this.target = selector ? document.querySelector(selector) : null;
      if (!this.bar || !this.target) return;

      this.frame = null;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.measure();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    onScroll() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.measure();
      });
    }

    measure() {
      var rect = this.target.getBoundingClientRect();
      /* Distance the body still has to travel past the top of the viewport.
         A body shorter than the viewport can never scroll, so it reads 100%
         rather than dividing by zero. */
      var travel = this.target.offsetHeight - window.innerHeight;
      var pct = travel > 0 ? Math.min(Math.max(-rect.top / travel, 0), 1) : 1;
      this.bar.style.setProperty('--progress', pct);
    }
  }

  if (!customElements.get('reading-progress')) {
    customElements.define('reading-progress', ReadingProgress);
  }
})();
